import { IComentario } from "../../../../services/comentarioService";
import CardComentario from "../CardComentario";
import { Container } from "./styles";

interface RespostasRecursivasProps {
    respostas: IComentario[];
    nivel: number;
    id_proposta: number;
    onRespostaCriada: () => void;
    onComentarioAtualizado?: () => void;
    onIniciarResposta?: (id_comentario: number) => void;
    comentarioRespondendo?: number | null;
    idComentarioPaiParaResposta?: number | null;
    onCancelarResposta?: () => void;
    todosComentarios?: IComentario[];
    user: {
        tipo: string;
        id?: string | number;
        id_operador?: number;
        id_usuario?: number;
        id_solicitante?: number;
        id_escritorio_solicitante?: number;
    };
    demanda?: any;
}

export default function RespostasRecursivas({ 
    respostas, 
    nivel, 
    id_proposta,
    onRespostaCriada,
    onComentarioAtualizado,
    onIniciarResposta,
    comentarioRespondendo,
    idComentarioPaiParaResposta,
    onCancelarResposta,
    todosComentarios = [],
    user,
    demanda
}: RespostasRecursivasProps) {
    if (!respostas || respostas.length === 0) {
        return null;
    }

    // Todas as respostas são renderizadas no mesmo nível (não há respostas de respostas)
    return (
        <Container nivel={nivel}>
            {respostas.map((resposta) => (
                <CardComentario
                    key={resposta.id_comentario}
                    comentario={resposta}
                    nivel={nivel}
                    id_proposta={id_proposta}
                    onRespostaCriada={onRespostaCriada}
                    onComentarioAtualizado={onComentarioAtualizado}
                    onIniciarResposta={onIniciarResposta}
                    comentarioRespondendo={comentarioRespondendo}
                    idComentarioPaiParaResposta={idComentarioPaiParaResposta}
                    onCancelarResposta={onCancelarResposta}
                    todosComentarios={todosComentarios}
                    user={user}
                    demanda={demanda}
                />
            ))}
        </Container>
    );
}

